/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_SaveInputs */

const en_task_save = /** @type {(inputs: Task_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes`)
};

const pt_br2_task_save = /** @type {(inputs: Task_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar alterações`)
};

/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Task_SaveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_save = /** @type {((inputs?: Task_SaveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_SaveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_save(inputs)
	return pt_br2_task_save(inputs)
});